export function header() {
    let header = document.querySelector('.header');
    header.style.position = "relative";

}
